import {
  IncentiveCategory,
  IncentiveProgram,
} from '@varo/graphql-schema-types';
import { formatShortPrizeDate } from 'features/incentive/helpers/formatPrizeDate';
import { getIncentiveCopyPrefix } from 'features/incentive/helpers/getIncentiveCopyPrefix';
import { useOpenUrlDocumentScreen } from 'features/urlDocumentScreens/hooks/useOpenUrlDocumentScreen';
import { useTranslation } from 'react-i18next';
import { StyleSheet } from 'react-native';
import BodySmText from 'shared/components/vxl/typography/primary/body/BodySmText';
import HyperlinkSmText from 'shared/components/vxl/typography/primary/hyperlink/HyperlinkSmText';
import theme from 'shared/styles/theme';

export type IncentiveDisclosureSection = 'intro' | 'howItWorks';

interface IncentiveDisclosureProps {
  incentiveType: IncentiveCategory;
  section: IncentiveDisclosureSection;
  program: Pick<
    IncentiveProgram,
    'termsAndConditionsUrl' | 'windowStart' | 'windowEnd'
  >;
}

function IncentiveDisclosure({
  incentiveType,
  section,
  program,
}: IncentiveDisclosureProps) {
  const { t: translatedText } = useTranslation('incentive', {
    keyPrefix: getIncentiveCopyPrefix(incentiveType, `disclosure.${section}`),
  });
  const { openWebUrlScreen } = useOpenUrlDocumentScreen();

  const handleTermsPress = () => {
    openWebUrlScreen(program.termsAndConditionsUrl);
  };

  return (
    <BodySmText numberOfLines={0} style={styles.disclosure}>
      {translatedText('body', {
        startDate: formatShortPrizeDate(program.windowStart),
        endDate: formatShortPrizeDate(program.windowEnd),
      })}{' '}
      <HyperlinkSmText role="link" onPress={handleTermsPress}>
        {translatedText('terms')}
      </HyperlinkSmText>{' '}
      {translatedText('end')}
    </BodySmText>
  );
}

const styles = StyleSheet.create({
  disclosure: {
    color: theme.color.text.secondary,
  },
});

export default IncentiveDisclosure;
